import { sessionStateService } from '@logz-pkg/frontend-services';
import { useObservable } from '@logz-pkg/observable';
import { resolveAiEnabled } from '@logz-pkg/utils';

export const useAiEnabled = (): boolean => {
  const session = useObservable(sessionStateService.session);

  return resolveAiEnabled(session?.accountSettings);
};

export const isAiEnabled = (): boolean => resolveAiEnabled(sessionStateService.session.get()?.accountSettings);
